import api from "./api";

export const followUpService = {
  // Sequences
  // `config` opcional (ex.: { signal }) é retrocompatível — chamadas antigas
  // sem argumento continuam funcionando.
  listSequences: (config = {}) => api.get("/follow-up/sequences", config),
  createSequence: (data) => api.post("/follow-up/sequences", data),
  updateSequence: (id, data) => api.put(`/follow-up/sequences/${id}`, data),
  deactivateSequence: (id) => api.delete(`/follow-up/sequences/${id}`),

  // Enrollments
  // `params` filtra (status, contactType, page, pageSize); `config` carrega
  // signal/AbortController. Retrocompatível com chamadas antigas (config default {}).
  listEnrollments: (params, config = {}) =>
    api.get("/follow-up/enrollments", { params, ...config }),
  resumeEnrollment: (id) => api.post(`/follow-up/enrollments/${id}/resume`),
  cancelEnrollment: (id) => api.post(`/follow-up/enrollments/${id}/cancel`),

  // Metrics
  getMetrics: (config = {}) => api.get("/follow-up/metrics", config),
};
